// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3I-gT","messages":"Chat_messages__2PVMJ","dateDivider":"Chat_dateDivider__33O3s"};